// Needs to have the same name as the Feature enum in CLB!

export enum FeatureSwitch {
  FEATURE_FOR_UNIT_TESTS = 'FEATURE_FOR_UNIT_TESTS',
  PPA_12148_HEYIMMO = 'PPA_12148_HEYIMMO',
  PPA_12241_AI_DATA_EXTRACTION_BANNER = 'PPA_12241_AI_DATA_EXTRACTION_BANNER',
  PPA_12616_RECOMMENDED_PRICE_FOURTH_ITERATION = 'PPA_12616_RECOMMENDED_PRICE_FOURTH_ITERATION',
  PPA_12428_AI_TEXT_GENERATION_DEVCOM_RENT = 'PPA_12428_AI_TEXT_GENERATION_DEVCOM_RENT',
  PPA_12594_OBJECT_CHOOSER_DRAFT_REUSE = 'PPA_12594_OBJECT_CHOOSER_DRAFT_REUSE',
}

export const FeatureSwitchesDefaultValues: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_12148_HEYIMMO]: false,
  [FeatureSwitch.PPA_12241_AI_DATA_EXTRACTION_BANNER]: false,
  [FeatureSwitch.PPA_12616_RECOMMENDED_PRICE_FOURTH_ITERATION]: false,
  [FeatureSwitch.PPA_12428_AI_TEXT_GENERATION_DEVCOM_RENT]: false,
  [FeatureSwitch.PPA_12594_OBJECT_CHOOSER_DRAFT_REUSE]: false,
}

export const ALL_FEATURES_ENABLED: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_12148_HEYIMMO]: true,
  [FeatureSwitch.PPA_12241_AI_DATA_EXTRACTION_BANNER]: true,
  [FeatureSwitch.PPA_12616_RECOMMENDED_PRICE_FOURTH_ITERATION]: true,
  [FeatureSwitch.PPA_12428_AI_TEXT_GENERATION_DEVCOM_RENT]: true,
  [FeatureSwitch.PPA_12594_OBJECT_CHOOSER_DRAFT_REUSE]: true,
}

export type FeatureSwitchMap = Partial<Record<FeatureSwitch, boolean>>
